import { styled } from 'stitches.config'

export const PurchaseHeroRoot = styled('section', {
  background: '$accent-white',
  padding: '$6 $3',
})

export const PurchaseHeroInner = styled('div', {
  maxWidth: '400px',
  margin: '0 auto',

  '@bp2': {
    maxWidth: '1200px',
    display: 'flex',
    flexDirection: 'row',
    gap: '$8',
    alignItems: 'center',
  },
})

export const ImageColumn = styled('div', {
  display: 'block',
  width: '100%',
  marginBottom: '$4',

  '@bp2': {
    width: '50%',
    marginBottom: 0,
    order: 1,
  },
})

export const HeroImageWrapper = styled('div', {
  position: 'relative',
  aspectRatio: '4/3',
  width: '100%',
})

export const ContentColumn = styled('div', {
  width: '100%',

  '@bp2': {
    width: '50%',
    order: -1,
  },
})

export const Headline = styled('h1', {
  fontFamily: '$display',
  fontSize: '$h2',
  lineHeight: '$h2',
  letterSpacing: '$h2',
  marginBottom: '$3',

  '@bp2': {
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$h1',
  },
})

export const Description = styled('p', {
  fontSize: '$body',
  lineHeight: '$body',
  marginBottom: '$4',
})

export const SelectorCard = styled('div', {
  background: '$tertiary-200',
  borderRadius: '8px',
  border: '1px solid $tertiary-300',
  padding: '$4 $3',
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
})

export const SelectorGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '400px',
})

export const SelectorLabel = styled('span', {
  fontFamily: '$labels',
  fontSize: '$caption',
  lineHeight: '$caption',
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  marginBottom: '$1',
  display: 'block',
})

export const QuantityLabelRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$1',
})

export const ToggleRow = styled('div', {
  display: 'flex',
  gap: '$1',
})

export const ToggleButton = styled('button', {
  flex: 1,
  border: '1px solid $secondary-500',
  borderRadius: '4px',
  fontFamily: '$labels',
  fontSize: '$caption',
  letterSpacing: '0.04em',
  padding: '$2',
  cursor: 'pointer',
  background: '$accent-white',
  color: '$secondary-500',
  transition: 'background 0.15s, color 0.15s',

  variants: {
    active: {
      true: {
        background: '$secondary-500',
        color: '$accent-white',
      },
      false: {
        background: '$accent-white',
        color: '$secondary-500',
      },
    },
  },

  defaultVariants: {
    active: false,
  },
})


export const SubscribeMessage = styled('p', {
  textAlign: 'center',
  fontSize: '$body',
  lineHeight: '$body',
})

export const TooltipTrigger = styled('button', {
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  color: '$secondary-500',
  marginBottom: '$1',
})
